import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';

class ScrollItem__Projects extends Scroll_Item {
    _call;
    _slider;
    _current = -1;
    _total = 0;
    _visor;
    _items = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if(!isSmartphone) {
            this._visor = GetBy.class("__visor", this.item);

            this.setupVisor();
        
            this.onMove = () => {
                const next = Math.floor(this._total * this.progressInside);
                this.showNext(next);
                //this.hideNext(Math.floor(this._total * (this.progressInside - .1)));
            };

            this._call = (e) => this.hover(e);
            document.addEventListener(Basics.moveEvent, this._call);
            this.showNext(0);
        }
    }

    hideNext(next) {
        if(next < 0)  return;
       

        this._items[next].link.style.opacity = 0;
    }

    showNext(next) {
        if(this._current == next)  return;
        if(next >= this._total) return;

        if(this._current >= 0) {
            this._items[this._current].image.classList.remove("--show");
            this._items[this._current].link.classList.remove("--show");
        }

        this._items[next].image.classList.add("--show");
        this._items[next].link.classList.add ("--show");
        this._current = next;
    }


    setupVisor() {
        const items = [... GetBy.class("__item", this.visor)];
        const links = [... GetBy.class("__link", this.visor)];

        for(let i=0; i<items.length; i++) {
            links[i].setAttribute("data-image", i);
            this._total = this._items.push({
                image: items[i],
                link: links[i]
            });
        }

        console.log(this._items)
    }

    hover(e) {
        switch (e.target.tagName.toLowerCase()) {
            case "a":
            //NOT ANCHOR
            const n = e.target.getAttribute("data-image");
            if (n) {
                this.showNext(Number(n));
            }

            break;
        }
    }

    resize(w, h) {
        super.resize(w, h);
    }

    loop() {}

    dispose() {
        super.dispose();
        if(!isSmartphone) document.removeEventListener(Basics.moveEvent, this._call);
    }
}

Scroll._registerClass('Projects', ScrollItem__Projects);
